import { render, staticRenderFns } from "./resumenPTI.vue?vue&type=template&id=659752f6&scoped=true"
import script from "./resumenPTI.vue?vue&type=script&lang=js"
export * from "./resumenPTI.vue?vue&type=script&lang=js"
import style0 from "./resumenPTI.vue?vue&type=style&index=0&id=659752f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659752f6",
  null
  
)

export default component.exports